import { Toaster as Sonner, toast } from 'sonner';
import React from 'react';

import { Loading, Success, Warning, Error, Info } from '../icons';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex px-4 py-3 text-contrast rounded-md text-xs gap-1.5 items-center shadow-md shadow-neutral/20 w-full',
          warning: 'bg-warning text-default',
          success: 'bg-success',
          error: 'bg-critical',
          info: 'bg-default',
        },
      }}
      icons={{
        success: <Success />,
        warning: <Warning />,
        loading: <Loading />,
        error: <Error />,
        info: <Info />,
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
